import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";
import config from "config/config";
import { SVGComponentProps } from "untitledui-js-base";

export const MenuRow = ({
  text,
  isDisabled = false,
  HugeIcon,
  Icon
}: {
  text: string;
  isDisabled?: boolean;
  HugeIcon?: IconSvgElement;
  Icon?: React.FC<SVGComponentProps>;
}) => {
  if (config.environment !== "production" && HugeIcon && Icon)
    throw new Error("Don't pass Icon and HugeIcon. Pick one");

  return (
    <span className="flex gap-2 items-center">
      {HugeIcon ? (
        <HugeiconsIcon
          size={20}
          icon={HugeIcon}
          className={isDisabled ? "text-content-100" : "text-content-200"}
        />
      ) : null}
      {Icon ? (
        <Icon
          size="20"
          className={isDisabled ? "stroke-content-100" : "stroke-content-200"}
        />
      ) : null}

      <p className={isDisabled ? "text-content-100" : "text-content-1000"}>
        {text}
      </p>
    </span>
  );
};
